const doc = [({"en":({"js":({"sheet_layouts":({"presentation":({"index":({"zoom":"Zoom", "rotate_left":"Rotate left", "rotate_right":"Rotate right"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;